// removed by extract-text-webpack-plugin
module.exports = {"body":"src-components-CategoryGallery----category-module---body---1NHOs","section":"src-components-CategoryGallery----category-module---section---1XLAB","grid":"src-components-CategoryGallery----category-module---grid---2Qcy_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryGallery/category.module.css
// module id = 672
// module chunks = 35783957827783